import { createContext, useContext } from "react";

import { Patient } from "../../core";

const patientContext = createContext<Patient | undefined>(undefined);

export const usePatientContext = () => useContext(patientContext);

export const PatientContextProvider = patientContext.Provider;
